// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"0e90a3ec","213":"89dd0012","261":"3e5ad60c","321":"06ca1110","479":"11a8856e","594":"5521a1a2","625":"fd372b29","630":"74298c02","698":"0bf7bb3a","853":"475a4343"}[chunkId] + ".chunk.js";
};